<template>
  <session class="page-claims">
    <TopNavs :list="navs" :target="curNav" @click="(target) => tabNav(target)" />
    <div class="page-claims-i js-page-claims">
      <div ref="bannerRef">
        <Banner :title="bannerTitle" :content="bannerContent" :cover="IMG_BANNER_COVER" />
      </div>
      
      <div class="claims-block" ref="block1Ref">
        <div class="block1-body">
          <div class="block-body-content">
            <div class="block-body-content-l">
              <span class="title" :class="{ ffen: getLocalLangCode() != 'zh' }">{{ block1Title }}</span>
              <span class="desc">{{ block1Desc }}</span>
            </div>
            <div class="block-body-content-r">
              <div class="item" :class="{ active: item?.name == block1ListCurItem?.name }" v-for="(item, index) in block1List" :key="index"  @click.stop="item.action">
                <div class="line" />
                <div class="title"><Icon :name="item.icon" size="40" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{ item?.name }}</span></div>
                <div class="desc-wrap">
                  <span class="desc" v-html="Utils.presetHtmlText(item?.desc)" />
                  <template v-if="item?.type == 'customerservice'">
                    <div class="checkmore"><Icon name="contactonline-blue" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.btntxt}}</span></div>
                  </template>
                  <template v-else>
                    <div class="checkmore"><Icon name="checkmore" size="48" /><span :class="{ ffen: getLocalLangCode() != 'zh' }">{{item?.btntxt}}</span></div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  </session>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import * as Utils from '@/assets/utils';
  import Banner from '@/components/banner/index.vue';
  import TopNavs from '@/components/topnavs/index.vue';
  import Icon from '@/components/icon/index.vue';
  import EventBus from '@/assets/eventbus';
  import Footer from '@/components/footer/index.vue';

  // imgs
  import IMG_BANNER_COVER from './images/cover.png';
  import IMG_BLOCK1_1 from './images/block1-1.png';
  import { LOCAL, getLocalLangCode } from '@/assets/lang';

  /**
   * navs
   */
  // nav list
  const navs = ref([
    { id: 1, label: LOCAL('claims_claims') },
    { id: 2, label: LOCAL('claims_application_inquiry') }
  ]);
  // nav target
  const bannerRef = ref(null);
  const block1Ref = ref(null);
  // cur nav
  const curNav = ref(null);
  const tabNav = (target, isJump) => {  
    if(isJump) {
      curNav.value = target;
      return;
    }
    // 滚动到……
    if(target?.id == 1 && bannerRef.value) {
      bannerRef.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
    if(target?.id == 2 && block1Ref.value) {
      block1Ref.value.scrollIntoView({ behavior: 'smooth', block: 'start', inline: "nearest" });  
    }
  }
  onMounted(() => {
    tabNav(navs.value[0], true);
  });
  const scrollHandle = () => {
    const el = document.querySelector('.js-page-claims');
    el.addEventListener('scroll', e => {
      const curpoi = e.target.scrollTop + 84 + 78;
      if(curpoi > block1Ref.value.offsetTop) {
        tabNav(navs.value[1], true);
      }else if(curpoi > bannerRef.value.offsetTop){
        tabNav(navs.value[0], true);
      }
    });
  }
  onMounted(() => {
    scrollHandle()
  })

  // banner
  const bannerTitle = ref('')
  const bannerContent = ref('')
  const bannerInit = () => {
    bannerTitle.value = LOCAL('claims_claims');
    bannerContent.value = LOCAL('claims_claims_desc');
  }
  onMounted(() => {
    bannerInit()
  });

  // 合作伙伴
  const block1Title = ref('');
  const block1Desc = ref('');
  const block1List = ref([]);
  const block1ListCurItem = ref(null);
  const block1ListTab = (index = 0) => {
    block1ListCurItem.value = block1List.value[index];
  }
  const block1Init = () => {
    block1Title.value = LOCAL('claims_application_inquiry');
    block1Desc.value = LOCAL('claims_application_inquiry_desc');
    block1List.value = [
      { 
        icon: 'onlineservice', 
        name: LOCAL('claims_application_inquiry_method1_title'), 
        btntxt: LOCAL('claims_application_inquiry_login'),
        action: () => Utils.loginDialogToggle(true),
        desc: LOCAL('claims_application_inquiry_method1_desc')
      },
      { 
        icon: 'customerservice', 
        name: LOCAL('claims_application_inquiry_method2_title'), 
        btntxt: LOCAL('contact'),
        action: () => Utils.toTargetPage('/contactus'),
        type: 'customerservice',
        desc: LOCAL('claims_application_inquiry_method2_desc') 
      },
    ]
  }
  onMounted(() => {
    block1Init();
    block1ListTab();
  })

  // 左侧回到顶部交互
  onMounted(() => {
    Utils.scrollToTop.register('js-page-claims');
    EventBus.on('global_page_scroll_action_js-page-claims', () => {
      tabNav(navs.value[0]);
    });
  });
</script>

<style scoped lang="less">
  @import "index.less";
</style>
